import { render, staticRenderFns } from "./voicemail-greeting.vue?vue&type=template&id=8fc7edfa&"
import script from "./voicemail-greeting.vue?vue&type=script&lang=js&"
export * from "./voicemail-greeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports